module.exports = "/_next/static/images/92bbeda4317b946bedaefc317adfaafa-roxinho-basicos-flutuantes-xs@1x.png";